import {
  EndpointInterface,
  ENDPOINT_ACCESS_MANAGEMENT_CLINIC_ACCESS_PERMISSIONS,
} from '@surglogs-app/network'

export const getPermissions =
  (
    apiVersion: string,
    clinicId: number,
    srn: string | string[],
  ): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_CLINIC_ACCESS_PERMISSIONS,
        params: [apiVersion, clinicId],
      },
      method: 'get',
      query: { srn },
      arrayInFormatWithDuplicatedKeys: true,
    })
